export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api/v1'

export const APP_NAME = 'Digital Agronomist'

// Map tiles are proxied through our own backend (`/map/tiles/{style}/{z}/{x}/{y}`),
// so the MapTiler key stays server-side and the same URL works for web and mobile.
export const MAP_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

// Selectable map styles. Keys must match the backend allowlist (supportedStyles).
export const MAP_STYLES = [
  { key: 'hybrid', label: 'Гибрид' },
  { key: 'satellite', label: 'Спутник' },
  { key: 'streets', label: 'Схема' },
] as const

export type MapStyleKey = (typeof MAP_STYLES)[number]['key']

export const DEFAULT_MAP_STYLE: MapStyleKey = 'hybrid'

export const mapTileUrl = (style: MapStyleKey): string =>
  `${API_BASE_URL}/map/tiles/${style}/{z}/{x}/{y}`

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  REPORTS: '/reports',
  TEMPLATES: '/reports/templates',
} as const
